import React from 'react';

const Footer = () => {
    return (
        <div className='text-center'>
           <p><small>Copyright coming soon</small></p>
        </div>
    );
};

export default Footer;